import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { derivedSelectorId } from 'selectors/externalAccount';
import { load } from 'model/exterrnalAccountAudit';
import {
  selectorCount,
  selectorGroupedByDays,
} from 'selectors/externalAccountAudit';
import Audit from 'components/common/Audit';
import AuditDrawerAppBarEndAdornment from 'components/common/Audit/config/shared/AuditDrawerAppBarEndAdornment';
import AuditDetailRowRecord from 'components/common/Audit/config/shared/AuditDetailRowRecord';
import AuditDrawerAppBarTitle from '../../../../Audit/config/shared/AuditDrawerAppBarTitle';

const ActionsRenderer = ({ item }) => {
  return (
    <Grid container justifyContent="flex-end">
      <Grid item>
        <Audit
          action={load}
          countSelector={selectorCount}
          DrawerEndAdornment={AuditDrawerAppBarEndAdornment}
          item={item}
          Row={AuditDetailRowRecord}
          selectorGroupedByDays={selectorGroupedByDays}
          selectorId={derivedSelectorId}
          Title={AuditDrawerAppBarTitle}
        />
      </Grid>
    </Grid>
  );
};

ActionsRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ActionsRenderer;
